var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 23 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mail_svg__a)",
    d: "M2.064 18c-.588 0-1.079-.198-1.472-.594C.197 17.009 0 16.515 0 15.924V2.076C0 1.485.197.991.592.596.985.197 1.476 0 2.064 0h18.872c.588 0 1.079.198 1.472.595.395.396.592.89.592 1.481v13.848c0 .591-.197 1.085-.59 1.48-.395.398-.886.596-1.474.596H2.064ZM11.5 9.148 1.278 2.424v13.5c0 .23.073.42.22.568a.763.763 0 0 0 .566.222h18.872c.23 0 .418-.074.565-.222a.773.773 0 0 0 .221-.568v-13.5L11.5 9.148Zm0-1.434 9.829-6.428H1.67L11.5 7.714ZM1.278 2.424V1.286v14.638c0 .23.073.42.22.568a.763.763 0 0 0 .566.222h-.786V2.424Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "mail_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(47.557 -4.652 16.63) scale(9.99023 240.528)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#F0CAB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC836D"
  })))));
};
export default SvgMail;